export default function (caseNumber) {
  return {
    name: "RFI Response",
    pageInfo: {
      text: "Please upload the response to your Request for Information below. Your response will be added to the case documents and directed to an analyst for review.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "RFI Response",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "RFI_Response_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            required: true,
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
          {
            machine_name: "case_note",
            widget: "text_area",
            validate: [
              {
                isRequired: "files",
                message: "This field is required",
                needsFieldValues: true,
                extraData: {
                  emptyArray: true,
                },
              },
            ],
            label: "Case Note",
            inputLimit: 4000,
            rows: 7,
          },
          {
            label: "Acknowledgment",
            widget: "checkbox",
            machine_name: "acknowledged",
            choice:
              "I provide OFLC with permission to update my Form ETA-9141 with the information submitted in this response.",
            required: true,
            validate: [
              {
                subsetOfSetRequired: "acknowledgedSub",
                message: "This field is required.",
                needsFieldValues: true,
                extraData: {
                  numRequired: 1,
                  fieldArray: ["acknowledged"],
                },
              },
            ],
          },
        ],
      },
    ],
  };
}
